import React from 'react';
import "./Header.css";



export default function Header(){
    return (
        <div className="header">
            <h1>Sorting Visualizer</h1>
        </div>
    )
}